/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import { estados } from "constants/common/formConstants";
import { booleanOptions } from "constants/common/formConstants";
import { format } from "date-fns";
import { severidades } from "constants/common/formConstants";
import { IconButton } from "@mui/material";
import { EyeOutlined } from "@ant-design/icons";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { createDrawerState, DrawerSchema } from "schemas";
import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import { userData } from "schemas";
import { locais } from "schemas";
import { safeJsonParse } from "utils/common/safeJsonParse";

const header = (object) => {
  return [
    { table: true, Header: "o que aconteceu?", accessor: "descricao", width: "45%", align: "left", width: 70 },
    { table: false, Header: "descrição", accessor: "detalhes", width: "45%", align: "left", width: 70 },
    { table: true, Header: "classe", accessor: "classe", align: "left", width: 15 },
    { table: true, Header: "local", accessor: "local", align: "center", width: 25 },
    { table: true, Header: "data", accessor: "data", align: "center", width: 25 },
    { table: false, Header: "Reportado por", accessor: "owner", align: "left", width: 25 },
    { table: false, Header: "Accão imediata", accessor: "accaoImediata", align: "center", width: 25 },
    { table: false, Header: "Data de arprovação", accessor: "dataAprovacao", align: "center", width: 25 },
    { table: false, Header: "data de fecho", accessor: "dataFecho", align: "center", width: 25 },
    { table: object === 'nearmisses', Header: "stop card", accessor: "stopCard", align: "center", width: 15 },
    { table: object === 'acidente', Header: "severidade", accessor: "severidade", align: "center", width: 20 },
    { table: true, Header: "estado", accessor: "estado", align: "center", width: 25 },
    { table: false, Header: "Responsáveis", align: "center", width: 25 },
    { table: true, Header: "acções", accessor: "accoes", align: "center", exportable: false }
  ]
}

export function nearMissData({ data, object, best = false }) {
  const setOpen = useSetRecoilState(DrawerSchema)
  const navigate = useNavigate()
  const user = useRecoilValue(userData)
  const locations = useRecoilValue(locais)
  const parsedResponsibles = (item) => {
    const responsibles = safeJsonParse(item?.responsaveis, [])
    return Array.isArray(responsibles) ? responsibles : []
  }

  const getEditors = (item) => [
    Number(item?.reportado_por) === Number(user.id) ? Number(user.id) : 0,
    ...parsedResponsibles(item)
  ].filter(Boolean)

  const openDetails = (item) => setOpen(createDrawerState({
    open: true,
    object,
    data: item,
    editors: getEditors(item)
  }))

  const Author = ({ item }) => (
    <MDBox role="button" tabIndex={0} style={{ cursor: "pointer" }} onClick={() => openDetails(item)} onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') openDetails(item) }} display="flex" alignItems="center" lineHeight={1}>
      <MDTypography display="flex" variant="button" fontWeight="medium">
        {item?.descricao?.length > 60
          ? item.descricao.substring(0, 60) + '...'
          : item?.descricao}
      </MDTypography>
    </MDBox>
  );

  return {
    columns: header(object),
    data: data?.map((item, _) => {
      return {
        ...item,
        local: locations?.find(x => x.value === item.local)?.label,
        stopCard: booleanOptions.find(x => x.value === item.stop_card)?.label,
        severidades: severidades.find(x => x.value === item.severidade)?.label,
        estado: estados.find(x => x.value === item.estado)?.label
      }
    }),
    rows: data?.map((item, _) => {
      return {
        descricao: <Author item={item} />,
        classe: (<MDTypography component="a" variant="caption" color="text" fontWeight="medium">
          {item.classe}
        </MDTypography>),
        local: (
          <MDTypography component="a" variant="caption" color="text" fontWeight="medium">
            {locations.find(x => x.value === item.local)?.label}
          </MDTypography>
        ),
        data: (
          <MDTypography component="a" variant="caption" color="text" fontWeight="medium">
            {format(new Date(item?.dataAcontecimento), 'dd-MM-yyyy')}
          </MDTypography>
        ),
        stopCard: <MDTypography component="a" variant="caption" color="text" fontWeight="medium">
          {booleanOptions.find(x => x.value === item.stop_card)?.label}
        </MDTypography>,
        severidade: <MDBox ml={-1}>
          <MDBadge badgeContent={severidades.find(x => x.value === item.severidade)?.label} color={severidades.find(x => x.value === item.severidade)?.color} variant="gradient" size="sm" />
        </MDBox>,
        estado: (
          <MDBox ml={-1}>
            <MDBadge badgeContent={estados.find(x => x.value === item.estado)?.label} color={estados.find(x => x.value === item.estado)?.color} variant="gradient" size="sm" />
          </MDBox>
        ),
        accoes: (
          <div>
            <IconButton aria-label="Ver detalhes" onClick={() => openDetails(item)} >
              <EyeOutlined />
            </IconButton>

            {!best && <IconButton aria-label="Editar registo" disabled={!(String(user?.acesso) !== "1" || Number(user?.id) === Number(item?.reportado_por))} onClick={() => {
              setOpen(createDrawerState({ update: true, object, data: item }))
              navigate('/reportar')
            }}>
              <EditIcon />
            </IconButton>}
          </div >
        ),
      };
    }),
  };
}
